if (!customElements.get('zimma-nav-item')) {
  customElements.define(
    'zimma-nav-item',
    class ZimmaNavItem extends HTMLElement {
      constructor() {
        super();
        this.trigger = this.querySelector('[data-zimma-mega-trigger]');
        this.panel = this.querySelector('[data-zimma-mega-panel]');
        if (!this.trigger || !this.panel) return;

        this.addEventListener('mouseenter', () => this.open());
        this.addEventListener('mouseleave', () => this.close());
        this.addEventListener('focusin', () => this.open());
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.close();
        });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.classList.contains('is-open')) {
            this.close();
            this.trigger.focus();
          }
        });
      }

      open() {
        this.classList.add('is-open');
        this.trigger.setAttribute('aria-expanded', 'true');
        this.panel.hidden = false;
      }

      close() {
        this.classList.remove('is-open');
        this.trigger.setAttribute('aria-expanded', 'false');
        this.panel.hidden = true;
      }
    }
  );
}
